import {
  DataQueryKey,
  UseDataQuery,
  UseDataQueryKey,
} from '../../../hooks/useDataQuery/dataQuery.types';
import {
  FindOrderConditionParams,
  FindOrderConditionsClassificationTypesParams,
} from './orderCondition.types';

export const getFindOrderConditionsKey = (params: FindOrderConditionParams): UseDataQueryKey => {
  return [DataQueryKey.ORDER_CONDITIONS, params.orderId];
};

export const getFindOrderConditionsCustomFieldsKey = (): UseDataQuery['queryKey'] => [
  'orders/order-conditions/custom-fields',
];

export const getFindOrderConditionsClassificationTypesKey = (
  params: FindOrderConditionsClassificationTypesParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.ORDER_CONDITIONS_CLASSIFICATION_TYPES,
  undefined,
  params,
];
